import {
  IAsset,
  IUnitAreaAsset,
} from 'src/services/api/UnitAreaAssets/apiContracts';

export const assetMatchesQuery = (
  assetName: string,
  areaName: string,
  searchQuery: string
): boolean => {
  const normalizedSearchQuery: string = searchQuery.toLowerCase();

  return (
    assetName.toLowerCase().includes(normalizedSearchQuery) ||
    areaName.toLowerCase().includes(normalizedSearchQuery)
  );
};

export const filterAssetsForArea = (
  area: IUnitAreaAsset,
  searchQuery: string
): IUnitAreaAsset['assets'] => {
  if (!searchQuery) {
    return area.assets;
  }

  return area.assets.filter((asset: IAsset) =>
    assetMatchesQuery(asset.item?.name ?? '', area.name, searchQuery)
  );
};

export const filterAreasByQuery = (
  areas: IUnitAreaAsset[],
  searchQuery: string
): IUnitAreaAsset[] => {
  const areasWithFilteredAssets: IUnitAreaAsset[] = areas.map(
    (area: IUnitAreaAsset) => ({
      ...area,
      assets: filterAssetsForArea(area, searchQuery),
    })
  );

  const areasWithAssets: IUnitAreaAsset[] = areasWithFilteredAssets.filter(
    (area: IUnitAreaAsset) => area.assets.length > 0
  );

  return areasWithAssets;
};
